import * as React from 'react';
import type { UseControllerReturn } from 'react-hook-form';

type FieldController = UseControllerReturn<any, any>;

export const FieldControllerContext = React.createContext<FieldController | null>(null);

/**
 * Provide a field controller to child components.
 */
export function FieldControllerProvider(props: {
    controller: FieldController;
    children: React.ReactNode;
}) {
    return (
        <FieldControllerContext.Provider value={props.controller}>
            {props.children}
        </FieldControllerContext.Provider>
    );
}

/**
 * Access the controller provided by the nearest `FieldControllerProvider`.
 */
export function useFieldController() {
    return React.useContext(FieldControllerContext);
}
